module.exports = __webpack_public_path__ + "media/images/favicon-41dc47ac60d7c89f5b424e1e172287cc.ico";